"use client";
import { Input } from "antd";
import type { InputProps } from "antd";

function AppHInput(props: InputProps) {
  return <Input {...props} type="hidden" />;
}

export { AppHInput };
